import { t } from "./kieli";

/**
 * T685 (Toni 29.10.2026 klo 14.45 kohta 2): näkymä, joka valitsee ensimmäisen kohteen listalta, sanoo ääneen, kun tunnuksella ei ole
 * yhtään näkyvää kohdetta. Ennen tätä Kohde-valikko jäi tyhjäksi eikä haku lähtenyt lainkaan, ja ruutu näytti siltä, ettei hakusanalla
 * löydy mitään (toma 29.10.: tunnus, jolla rooli Tarkastaja ja 0 kohdesidontaa, `naekeeKaiken` = false).
 * `haettu` = kohdelista on saatu onnistuneesti. Se on kohdelistan oma tila, ei näkymän yhteinen lataus: Työpaketeissa yhteinen lataus
 * kaatui rajatulla tunnuksella henkilöstöhakuun, ja ilmoitus jäi piiloon (k120 29.10.).
 */
export function EiKohteita({ haettu, kohteita }: { haettu: boolean; kohteita: number }) {
  if (!haettu || kohteita > 0) return null;
  return <p role="status" data-ei-kohteita="" style={{ fontWeight: 600, borderLeft: "4px solid var(--varoitus)", paddingLeft: 10 }}>{t("kohde.ei_nakyvia")}</p>;
}
